"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3386 6.1217C8.531 7.5757 8 9.6519 8 12c0 2.3481.5309 4.4244 1.3386 5.8783C10.1652 19.3661 11.1474 20 12 20s1.8348-.6339 2.6614-2.1217C15.4691 16.4244 16 14.3481 16 12c0-2.348-.5309-4.4244-1.3386-5.8783C13.8348 4.6339 12.8526 4 12 4s-1.8348.6339-2.6614 2.1217zm-1.7483-.9713C8.5734 3.3808 10.0912 2 12 2c1.9088 0 3.4266 1.3808 4.4097 3.1504C17.4116 6.9538 18 9.3774 18 12c0 2.6225-.5884 5.0462-1.5903 6.8496C15.4266 20.6192 13.9088 22 12 22c-1.9088 0-3.4266-1.3808-4.4097-3.1504C6.5884 17.0462 6 14.6225 6 12c0-2.6225.5884-5.0462 1.5903-6.8496z"
  })];
};

exports.default = _default;